unit DisposableItemListType;
{

/* Initial. */

}

interface

uses
  DisposableItemType;

type
  TDisposableItemListType = array of TDisposableItemType;

implementation

end.
